import { oktaAuth, OKTA_ENABLED } from "./okta.js";

/**
 * Authenticated fetch — attaches Bearer token when OKTA_ENABLED.
 */
export async function authFetch(input, init) {
  if (!OKTA_ENABLED) {
    return fetch(input, init);
  }

  let bearerToken;
  try {
    const tokenObj = await oktaAuth.tokenManager.get("accessToken");
    bearerToken = tokenObj?.accessToken;
  } catch {
    console.warn("[authFetch] Could not retrieve Okta access token");
  }

  const existingHeaders = (init?.headers && typeof init.headers === "object" && !(init.headers instanceof Headers))
    ? init.headers
    : {};
  const headers = {
    ...existingHeaders,
    ...(bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {}),
  };

  return fetch(input, { ...init, headers });
}
